import * as Redux from 'redux'
import * as Form from '../../components/form'
import * as IsActive from '../../components/is_active'
import * as Modal from '../../components/modal'
import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

export type Options = Request.RequestOptions<null, Types.FetchMembersParams>
export type FetchMembersAction = Request.RequestAction<Options>
export type FetchMembers = (communityIdentifier: string, params: Types.FetchMembersParams) => FetchMembersAction
export const fetchMembers: FetchMembers =
  (communityIdentifier: string, params: Types.FetchMembersParams = null) =>
  Request.requestActionCreator<Options>(Constants.FETCH_MEMBERS)
  ({
    method: 'GET',
    params,
    url: `${Constants.SERVER_RESOURCE}/${communityIdentifier}`,
  })

export type FetchMembersCountAction = Request.RequestAction<Options>
export type FetchMembersCount =
  (communityIdentifier: string, params: Types.FetchMembersParams) => FetchMembersCountAction
export const fetchMemberCounts: FetchMembers =
  (communityIdentifier: string, params: Types.FetchMembersParams = null) =>
  Request.requestActionCreator<Options>(Constants.FETCH_MEMBER_COUNTS)
  ({
    method: 'GET',
    params,
    url: `${Constants.SERVER_RESOURCE}/count/${communityIdentifier}`,
  })

export interface SortMembersAction extends Redux.Action { field: Types.Field }
export type SortMembersFn = (field: Types.Field) => SortMembersAction
export const sortMembers: SortMembersFn =  (field: Types.Field) =>
  ({type: Constants.SORT_MEMBERS, field})

export type ExportMembersAction = Request.RequestAction<Options>
export type ExportMembers = (communityIdentifier: string, params: Types.FetchMembersParams) => ExportMembersAction
export const exportMembers: ExportMembers =
  (communityIdentifier: string, params: Types.FetchMembersParams = null) =>
  Request.requestActionCreator<Options>(Constants.EXPORT_SUBSCRIBERS)
  ({
    method: 'GET',
    params,
    url: `${Constants.SERVER_RESOURCE}/${communityIdentifier}${Constants.EXPORT_RESOURCE}`,
  })

export type FetchMemberAction = Request.RequestAction<Request.RequestOptions>
export type FetchMember = Redux.ActionCreator<FetchMemberAction>
export const fetchMember: FetchMember =
  (communityIdentifier: string, communityPersonGuid: string) =>
  Request.requestActionCreator(Constants.FETCH_MEMBER)
  ({
    method: 'GET',
    url: `${Constants.SERVER_RESOURCE}/${communityIdentifier}/${communityPersonGuid}`,
  })

export type FetchMemberDetailsAction = Request.RequestAction<Request.RequestOptions>
export type FetchMemberDetails = Redux.ActionCreator<FetchMemberDetailsAction>
export const fetchMemberDetails: FetchMemberDetails =
  (communityIdentifier: string, communityPersonGuid: string) =>
  Request.requestActionCreator(Constants.FETCH_MEMBER_DETAILS)
  ({
    method: 'GET',
    url: `/members/${communityIdentifier}/${communityPersonGuid}/attributes`,
  })

let searchIndex: number = 0
export interface SearchMembersParams { q: string }
export const searchMembers = (value: string): Request.SearchAction => ({
  index: searchIndex++,
  type: Constants.ON_SEARCH,
  value,
})

export const searchFinished = (value: any) => ({
  type: Constants.ON_SEARCH_FINISHED,
  value,
})

export const showModal = () => ({type: Modal.toggleModalConstant(Constants.MEMBER_IMPORT)})
export const updateMembersImportModalField = (field: Modal.ModalField) =>
  ({type: Modal.updateModalConstant(Constants.MEMBER_IMPORT), field})

export const uploadCsv: Modal.Submit<Types.ModalData> = (community: string, payload: Types.ModalData) => {
  return Request.requestActionCreator(Constants.MEMBER_IMPORT)({
    method: 'POST',
    payload: {
      content: payload.content,
      name: payload.name,
    },
    url: `${Constants.MEMBER_IMPORT_SERVER_RESOURCE}/import/${community}`,
  })
}

export const updateIsActive: IsActive.UpdateStatusAction = (community: string, stateChange: IsActive.StateChange) =>
  Request.requestActionCreator(Constants.UPDATE_MEMBER_INLINE)({
    method: 'PUT',
    payload: IsActive.asUpdateBody(stateChange),
    url: `${Constants.SERVER_RESOURCE}/${community}/${stateChange.id}`,
  })

export type Update = (community: string, member: Types.Member) => Redux.Action
export const update: Update = (community, member) =>
  Request.requestActionCreator(Constants.UPDATE_MEMBER)({
    method: 'PUT',
    payload: member,
    url: `${Constants.SERVER_RESOURCE}/${community}/${member.id}`,
  })

export const FilterFormActions = Form.createActionsMap(Constants.MEMBERS_FILTERS)

export interface EditMemberAction extends Redux.Action { identifier: string }
export type EditMemberFn = (identifier: string) => EditMemberAction
export const editMember: EditMemberFn = (identifier: string) => ({type: Constants.ON_EDIT, identifier})



// WEBPACK FOOTER //
// ./src/pages/members/actions.ts